import { BASE_IMPORT_DATA } from "@/Modals/Profiles/BaseImport/baseImportData";
import React from "react";
import { columns } from "./Columns";
import { eventParticipantsApi } from "@/apis/apis";
import BaseTable from "./BaseTable";
import EventParticipantModal from "@/Modals/Profiles/EventParticipants/Modal";

export default function EventParticipantsPage() {
  return (
    <BaseTable
      label="Event Participants"
      apiURL={eventParticipantsApi}
      columns={columns()}
      ModalComponent={EventParticipantModal}
      importData={BASE_IMPORT_DATA.EVENT_PARTICIPANTS}
      enableSortData={false}
    />
  );
}
